import axiosFetch from './config';

export const getCards = async () => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: `/cards`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const postCards = async (data) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'POST',
    url: `/cards`,
    data: data,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const deleteCardById = async (id) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'DELETE',
    url: `/cards/${id}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const consultCardByNumber = async (number) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: `/cards/${number}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}
